/**
 * Created by andrey on 20.08.2021.
 */

const RewardedAdOverlay = cc.Scale9Sprite.extend({
    ctor: function (name) {
        this._super(bundles.pixel.frames.pixel_png);

        this.alwaysOn = true;

        this.setColor(cleverapps.styles.COLORS.BLACK);
        this.setOpacity(80);
        this.setLocalZOrder(Transition.ZORDER + 1);

        cleverapps.UI.onClick(this, () => {
            if (!this.closeText.isVisible()) {
                return;
            }

            const cancelled = connector.platform.oneOf(connector.YANDEX, connector.GDCOM, connector.COOLMATHGAMES, connector.TEST);
            connector.ads.finishAd(name, name === RewardedAdsManager.REWARDED && !cancelled ? connector.CODE_SUCCEED : "closed_by_user");
        }, {
            interactiveScale: false
        });

        this.addLoadText();
        this.addCloseText();
        this.onResize();
    },

    onResize: function () {
        const bgSize = cleverapps.resolution.getBgSize();
        const safePadding = cleverapps.resolution.getSafePadding();

        this.setContentSize2(bgSize.width + 4, bgSize.height + 4);
        this.setAlignment(bgSize.width / 2 - safePadding.left, bgSize.height / 2 - safePadding.bottom);
        this.setAnchorPoint(0.5, 0.5);

        if (this.loadText) {
            this.loadText.setAlignment(cleverapps.styles.RewardedAdOverlay.text);
        }

        if (this.closeText) {
            this.closeText.setDimensions(bgSize.width, bgSize.width);
            this.closeText.setAlignment(cleverapps.styles.RewardedAdOverlay.text);
        }
    },

    addLoadText: function () {
        const loadText = this.loadText = cleverapps.UI.generateOnlyText(Messages.get("Loading"), cleverapps.styles.FONTS.REWARDED_AD_OVERLAY_TEXT);
        loadText.setAlignment(cleverapps.styles.RewardedAdOverlay.text);
        this.addChild(loadText);
        loadText.setOpacity(0);

        loadText.runAction(new cc.Sequence(
            new cc.FadeIn(0.3),
            new cc.DelayTime(RewardedAdOverlay.CLOSE_AVAILABLE / 1000 - 0.6),
            new cc.FadeOut(0.3),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                delete this.loadText;
            })
        ));
    },

    addCloseText: function () {
        const closeText = this.closeText = cleverapps.UI.generateOnlyText(Messages.get("Window.TapToContinue"), cleverapps.styles.FONTS.REWARDED_AD_OVERLAY_TEXT);
        closeText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);
        closeText.setDimensions(cleverapps.resolution.getSceneSize().width, 0);
        closeText.fitTo(cleverapps.resolution.getSceneSize().width);
        closeText.setAlignment(cleverapps.styles.RewardedAdOverlay.text);
        closeText.visible = false;
        closeText.setOpacity(0);
        this.addChild(closeText);

        closeText.runAction(new cc.Sequence(
            new cc.DelayTime(RewardedAdOverlay.CLOSE_AVAILABLE / 1000),
            new cc.Show(),
            new cc.FadeIn(0.3)
        ));
    }
});

RewardedAdOverlay.initialize = function () {
    let closeAvailable = "5 seconds";

    if (connector.platform.oneOf(connector.GDCOM, connector.COOLMATHGAMES)) {
        closeAvailable = "15 seconds";
    }

    RewardedAdOverlay.CLOSE_AVAILABLE = cleverapps.parseInterval(closeAvailable);
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    REWARDED_AD_OVERLAY_TEXT: {
        size: 60,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.RewardedAdOverlay = {
    text: {
        x: { align: "center" },
        y: { align: "center" }
    }
};
